const reducers = require('./reducers');

module.exports = {
  ...reducers,
  getFlightsSearchQueryParams: require('./helpers/getFlightsSearchQueryParams'),
  searchHistoryLocalStorage: require('./helpers/searchHistoryLocalStorage'),
  searchUrlMap: require('./helpers/searchUrlMap'),
  parseRoute: require('./helpers/parseRoute'),
  form: require('./FlightsSearchForm'),
};
